export default {
    your_invoice: 'Your Invoice',
    billing_to: 'Billing to',
    invoice: 'Invoice#',
    customers_id: 'Customers ID',
    description: 'Description',
    qty: 'QTY',
    unit_price: 'Unit price',
    total_invoice: 'TOTAL',
    invoice_footer_thank: 'Thank you for your patronage!',
    invoice_footer_text: {
        1: 'The best cloud & hosting provider',
        2: 'Visit www.1byte.com for more information about our  products and promotions',
        notice: 'Notice to Thai legal entities: Please send the {whtPercent}% Withholding Tax Certificate to {noticeEmail}',
    },
    terms_text: 'I have read and agreed to the',
    terms_and_conditions: 'Terms and Conditions',
    due_upon_receipt: 'Due Upon Receipt ',
    date: 'Date',
    terms: 'Terms',
    amount: 'Amount',
    total: 'Total',
    invoice_id: 'Invoice#',
    customer_id: 'Customers ID',
    discount: 'Discount',
    actionRegister: 'Registration',
    actionRenew: 'Renewal',
    actionReactivate: 'Reactivation',
    actionTransfer: 'Transfer',
    actionPurchase: 'Purchase',
    actionUpgrade: 'Upgrade',
    actionBackup: 'Backup',
    zip_code: 'zip code: {value}',
    zip_code_invoice: 'zip code {value}',
    year: 'Year',
    years: 'Years',
    months: 'Months',
    month: 'Month',
    bank_info: {
        title: 'To pay please submit your payment as follows:',
        beneficiary: 'Beneficiary:',
        bank: 'Bank:',
        account_no: 'Account No:',
        swift_code: 'SWIFT code:',
    },
    amount_due: 'Amount Due',
};
